import { compactObject } from 'src/heplers'
import api from './api.service'
import authHeader from './auth-header'

class BreachesService {
  getBreaches(filters = {}) {
    const params = new URLSearchParams(compactObject(filters))
    return api.get('/v1/breaches', {
      headers: authHeader(),
      params
    })
  }
}

export default new BreachesService()
